import React from "react"
import styled from "styled-components"

const Select = styled.select`
  border: 1px solid #f7f7f7;
  padding: 5px;
  border-radius: 5px;
`
export default function MobilePicker() {
  return (
    <Select on name="cars" id="cars">
      <option value="volvo">Volvo</option>
      <option value="saab">Saab</option>
      <option value="mercedes">Mercedes</option>
      <option value="audi">Audi</option>
    </Select>
  )
}
